/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Business,
  BusinessCount,
  BusinessList,
  BusinessMapMarker,
  BusinessSearch,
  BusinessSettings,
  DealReward,
  DealWithRewards,
  PaginatedBusinessListList,
  PatchedBusinessSettings,
} from '../models';
import {
    BusinessFromJSON,
    BusinessToJSON,
    BusinessCountFromJSON,
    BusinessCountToJSON,
    BusinessListFromJSON,
    BusinessListToJSON,
    BusinessMapMarkerFromJSON,
    BusinessMapMarkerToJSON,
    BusinessSearchFromJSON,
    BusinessSearchToJSON,
    BusinessSettingsFromJSON,
    BusinessSettingsToJSON,
    DealRewardFromJSON,
    DealRewardToJSON,
    DealWithRewardsFromJSON,
    DealWithRewardsToJSON,
    PaginatedBusinessListListFromJSON,
    PaginatedBusinessListListToJSON,
    PatchedBusinessSettingsFromJSON,
    PatchedBusinessSettingsToJSON,
} from '../models';

export interface BusinessesAlternativesRetrieveRequest {
    id: string;
}

export interface BusinessesDealRewardsListRequest {
    id: string;
}

export interface BusinessesDealsListRequest {
    id: string;
    include_archived?: boolean;
}

export interface BusinessesFavoriteCreateRequest {
    id: string;
}

export interface BusinessesListRequest {
    amenities?: Array<BusinessesListAmenitiesEnum>;
    cuisines?: Array<BusinessesListCuisinesEnum>;
    diets?: Array<BusinessesListDietsEnum>;
    is_favorite?: boolean;
    is_open?: boolean;
    is_pro?: boolean;
    limit?: number;
    name?: string;
    offset?: number;
    ordering?: string;
    price_level?: BusinessesListPriceLevelEnum;
}

export interface BusinessesRequestDealCreateRequest {
    id: string;
}

export interface BusinessesRetrieveRequest {
    id: string;
}

export interface BusinessesSearchListRequest {
    query: string;
}

export interface BusinessesSettingsPartialUpdateRequest {
    id: string;
    PatchedBusinessSettings?: PatchedBusinessSettings;
}

export interface BusinessesSettingsRetrieveRequest {
    id: string;
}

export interface BusinessesSettingsUpdateRequest {
    id: string;
    BusinessSettings?: BusinessSettings;
}

export interface BusinessesUnfavoriteCreateRequest {
    id: string;
}

export interface BusinessesUnrequestDealCreateRequest {
    id: string;
}

/**
 * BusinessesApi - interface
 * 
 * @export
 * @interface BusinessesApiInterface
 */
export interface BusinessesApiInterface {
    /**
     * 
     * @param {string} id A unique integer value identifying this Business.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesAlternativesRetrieveRaw(requestParameters: BusinessesAlternativesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessList>>;

    /**
     */
    businessesAlternativesRetrieve(requestParameters: BusinessesAlternativesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessList>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesCountRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessCount>>;

    /**
     */
    businessesCountRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessCount>;

    /**
     * 
     * @param {string} id A unique integer value identifying this Business.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesDealRewardsListRaw(requestParameters: BusinessesDealRewardsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DealReward>>>;

    /**
     */
    businessesDealRewardsList(requestParameters: BusinessesDealRewardsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DealReward>>;

    /**
     * 
     * @param {string} id A unique integer value identifying this Business.
     * @param {boolean} [include_archived] Whether to include archived deals in the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesDealsListRaw(requestParameters: BusinessesDealsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DealWithRewards>>>;

    /**
     */
    businessesDealsList(requestParameters: BusinessesDealsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DealWithRewards>>;

    /**
     * 
     * @param {string} id A unique integer value identifying this Business.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesFavoriteCreateRaw(requestParameters: BusinessesFavoriteCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    businessesFavoriteCreate(requestParameters: BusinessesFavoriteCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {Array<1 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 2 | 20 | 21 | 22 | 23 | 25 | 26 | 27 | 3 | 4 | 5 | 6 | 7 | 8 | 9>} [amenities] Filter for businesses that have any of the given amenities.  * &#x60;1&#x60; - Free WiFi * &#x60;2&#x60; - Live Music * &#x60;3&#x60; - Brunch * &#x60;4&#x60; - Vegetarian Options * &#x60;5&#x60; - Vegan Options * &#x60;6&#x60; - Outdoor Seating * &#x60;7&#x60; - Offers Takeout * &#x60;8&#x60; - Offers Delivery * &#x60;9&#x60; - Kid Friendly * &#x60;10&#x60; - Wheelchair Accessible * &#x60;11&#x60; - Takes Reservations * &#x60;12&#x60; - Valet * &#x60;13&#x60; - Private Parking Available * &#x60;14&#x60; - Dogs Allowed * &#x60;15&#x60; - Has TV * &#x60;16&#x60; - Offers Military Discount * &#x60;17&#x60; - Happy Hour Specials * &#x60;18&#x60; - Full Bar * &#x60;19&#x60; - Beer and Wine Only * &#x60;20&#x60; - Arcade * &#x60;21&#x60; - Billiards * &#x60;22&#x60; - Darts * &#x60;23&#x60; - Shuffleboard * &#x60;25&#x60; - Trivia * &#x60;26&#x60; - Karaoke * &#x60;27&#x60; - Live Sports
     * @param {Array<1 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 2 | 20 | 21 | 22 | 23 | 24 | 25 | 26 | 27 | 28 | 29 | 3 | 30 | 31 | 32 | 33 | 34 | 35 | 36 | 37 | 38 | 39 | 4 | 40 | 41 | 42 | 43 | 44 | 45 | 46 | 47 | 48 | 49 | 5 | 50 | 51 | 52 | 53 | 54 | 55 | 56 | 57 | 58 | 59 | 6 | 60 | 61 | 62 | 63 | 64 | 65 | 66 | 67 | 68 | 69 | 7 | 70 | 71 | 72 | 73 | 74 | 75 | 76 | 77 | 78 | 79 | 8 | 80 | 81 | 82 | 83 | 9>} [cuisines] Filter for businesses that have any of the given cuisines.  * &#x60;1&#x60; - African * &#x60;2&#x60; - American * &#x60;3&#x60; - Asian Fusion * &#x60;4&#x60; - BBQ * &#x60;5&#x60; - Bar Food * &#x60;6&#x60; - Belgian * &#x60;7&#x60; - Breakfast * &#x60;8&#x60; - Beer * &#x60;9&#x60; - Burgers * &#x60;10&#x60; - Coffee * &#x60;11&#x60; - Cajun * &#x60;12&#x60; - Californian * &#x60;13&#x60; - Caribbean * &#x60;14&#x60; - Chicken * &#x60;15&#x60; - Chinese * &#x60;16&#x60; - Coffee and Tea * &#x60;17&#x60; - Crêpes * &#x60;18&#x60; - Deli Food * &#x60;19&#x60; - Desserts * &#x60;20&#x60; - Diner Food * &#x60;21&#x60; - Donuts * &#x60;22&#x60; - Drinks Only * &#x60;23&#x60; - European * &#x60;24&#x60; - Fast Food * &#x60;25&#x60; - Filipino * &#x60;26&#x60; - French * &#x60;27&#x60; - Fusion * &#x60;28&#x60; - German * &#x60;29&#x60; - Greek * &#x60;30&#x60; - Hawaiian * &#x60;31&#x60; - Healthy Food * &#x60;32&#x60; - Ice Cream * &#x60;33&#x60; - Indian * &#x60;34&#x60; - Italian * &#x60;35&#x60; - Japanese * &#x60;36&#x60; - Korean * &#x60;37&#x60; - Latin American * &#x60;38&#x60; - Mediterranean * &#x60;39&#x60; - Mexican * &#x60;40&#x60; - Middle Eastern * &#x60;41&#x60; - Moroccan * &#x60;42&#x60; - New American * &#x60;43&#x60; - Pakistani * &#x60;44&#x60; - Peruvian * &#x60;45&#x60; - Pizza * &#x60;46&#x60; - Poke * &#x60;47&#x60; - Portuguese * &#x60;48&#x60; - Pub Food * &#x60;49&#x60; - Ramen * &#x60;50&#x60; - Salads * &#x60;51&#x60; - Sandwiches * &#x60;52&#x60; - Scandinavian * &#x60;53&#x60; - Seafood * &#x60;54&#x60; - Southern * &#x60;55&#x60; - Southwestern * &#x60;56&#x60; - Spanish * &#x60;57&#x60; - Steakhouses * &#x60;58&#x60; - Sushi * &#x60;59&#x60; - Tapas * &#x60;60&#x60; - Tea * &#x60;61&#x60; - Thai * &#x60;62&#x60; - Vietnamese * &#x60;63&#x60; - Wine * &#x60;64&#x60; - Baked Goods * &#x60;65&#x60; - Cheese * &#x60;66&#x60; - Bagels * &#x60;67&#x60; - Juice and Smoothies * &#x60;68&#x60; - Hotdogs * &#x60;69&#x60; - Smoked Meats * &#x60;70&#x60; - Cocktails * &#x60;71&#x60; - Tacos * &#x60;72&#x60; - Groceries * &#x60;73&#x60; - Turkish * &#x60;74&#x60; - Chocolate * &#x60;75&#x60; - Bubble Tea * &#x60;76&#x60; - Macaroons * &#x60;77&#x60; - Acai Bowls * &#x60;78&#x60; - Wraps * &#x60;79&#x60; - Candy * &#x60;80&#x60; - Pretzels * &#x60;81&#x60; - Vegan * &#x60;82&#x60; - Vitamins and Supplements * &#x60;83&#x60; - Pastries
     * @param {Array<1 | 2 | 3 | 4 | 5 | 6 | 7>} [diets] Filter for businesses that have any of the given diets.  * &#x60;1&#x60; - Dairy Free * &#x60;2&#x60; - Gluten Free * &#x60;3&#x60; - Keto * &#x60;4&#x60; - Paleo * &#x60;5&#x60; - Vegan * &#x60;6&#x60; - Vegetarian * &#x60;7&#x60; - Whole 30
     * @param {boolean} [is_favorite] Is Favorite
     * @param {boolean} [is_open] Is Open
     * @param {boolean} [is_pro] 
     * @param {number} [limit] Number of results to return per page.
     * @param {string} [name] 
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {0 | 1 | 2 | 3 | 4} [price_level] Filter for businesses that have any of the given price levels.  * &#x60;0&#x60; - Free * &#x60;1&#x60; - Inexpensive * &#x60;2&#x60; - Moderate * &#x60;3&#x60; - Expensive * &#x60;4&#x60; - Very Expensive
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesListRaw(requestParameters: BusinessesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedBusinessListList>>;

    /**
     */
    businessesList(requestParameters: BusinessesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedBusinessListList>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesMapMarkersRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessMapMarker>>;

    /**
     */
    businessesMapMarkersRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessMapMarker>;

    /**
     * 
     * @param {string} id A unique integer value identifying this Business.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesRequestDealCreateRaw(requestParameters: BusinessesRequestDealCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    businessesRequestDealCreate(requestParameters: BusinessesRequestDealCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} id A unique integer value identifying this Business.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesRetrieveRaw(requestParameters: BusinessesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Business>>;

    /**
     */
    businessesRetrieve(requestParameters: BusinessesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Business>;

    /**
     * Provide the n best search results based on the search query provided.
     * @param {string} query The search query against which to match results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesSearchListRaw(requestParameters: BusinessesSearchListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BusinessSearch>>>;

    /**
     * Provide the n best search results based on the search query provided.
     */
    businessesSearchList(requestParameters: BusinessesSearchListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BusinessSearch>>;

    /**
     * 
     * @param {string} id A unique integer value identifying this Business.
     * @param {PatchedBusinessSettings} [PatchedBusinessSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesSettingsPartialUpdateRaw(requestParameters: BusinessesSettingsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessSettings>>;

    /**
     */
    businessesSettingsPartialUpdate(requestParameters: BusinessesSettingsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessSettings>;

    /**
     * 
     * @param {string} id A unique integer value identifying this Business.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesSettingsRetrieveRaw(requestParameters: BusinessesSettingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessSettings>>;

    /**
     */
    businessesSettingsRetrieve(requestParameters: BusinessesSettingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessSettings>;

    /**
     * 
     * @param {string} id A unique integer value identifying this Business.
     * @param {BusinessSettings} [BusinessSettings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesSettingsUpdateRaw(requestParameters: BusinessesSettingsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessSettings>>;

    /**
     */
    businessesSettingsUpdate(requestParameters: BusinessesSettingsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessSettings>;

    /**
     * 
     * @param {string} id A unique integer value identifying this Business.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesUnfavoriteCreateRaw(requestParameters: BusinessesUnfavoriteCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    businessesUnfavoriteCreate(requestParameters: BusinessesUnfavoriteCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} id A unique integer value identifying this Business.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessesApiInterface
     */
    businessesUnrequestDealCreateRaw(requestParameters: BusinessesUnrequestDealCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    businessesUnrequestDealCreate(requestParameters: BusinessesUnrequestDealCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class BusinessesApi extends runtime.BaseAPI implements BusinessesApiInterface {

    /**
     */
    async businessesAlternativesRetrieveRaw(requestParameters: BusinessesAlternativesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessList>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling businessesAlternativesRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/{id}/alternatives/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessListFromJSON(jsonValue));
    }

    /**
     */
    async businessesAlternativesRetrieve(requestParameters: BusinessesAlternativesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessList> {
        const response = await this.businessesAlternativesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async businessesCountRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessCount>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/count/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessCountFromJSON(jsonValue));
    }

    /**
     */
    async businessesCountRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessCount> {
        const response = await this.businessesCountRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async businessesDealRewardsListRaw(requestParameters: BusinessesDealRewardsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DealReward>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling businessesDealRewardsList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/{id}/deal-rewards/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DealRewardFromJSON));
    }

    /**
     */
    async businessesDealRewardsList(requestParameters: BusinessesDealRewardsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DealReward>> {
        const response = await this.businessesDealRewardsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async businessesDealsListRaw(requestParameters: BusinessesDealsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DealWithRewards>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling businessesDealsList.');
        }

        const queryParameters: any = {};

        if (requestParameters.include_archived !== undefined) {
            queryParameters['include_archived'] = requestParameters.include_archived;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/{id}/deals/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DealWithRewardsFromJSON));
    }

    /**
     */
    async businessesDealsList(requestParameters: BusinessesDealsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DealWithRewards>> {
        const response = await this.businessesDealsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async businessesFavoriteCreateRaw(requestParameters: BusinessesFavoriteCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling businessesFavoriteCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/{id}/favorite/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async businessesFavoriteCreate(requestParameters: BusinessesFavoriteCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.businessesFavoriteCreateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async businessesListRaw(requestParameters: BusinessesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedBusinessListList>> {
        const queryParameters: any = {};

        if (requestParameters.amenities) {
            queryParameters['amenities'] = requestParameters.amenities;
        }

        if (requestParameters.cuisines) {
            queryParameters['cuisines'] = requestParameters.cuisines;
        }

        if (requestParameters.diets) {
            queryParameters['diets'] = requestParameters.diets;
        }

        if (requestParameters.is_favorite !== undefined) {
            queryParameters['is_favorite'] = requestParameters.is_favorite;
        }

        if (requestParameters.is_open !== undefined) {
            queryParameters['is_open'] = requestParameters.is_open;
        }

        if (requestParameters.is_pro !== undefined) {
            queryParameters['is_pro'] = requestParameters.is_pro;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.price_level !== undefined) {
            queryParameters['price_level'] = requestParameters.price_level;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedBusinessListListFromJSON(jsonValue));
    }

    /**
     */
    async businessesList(requestParameters: BusinessesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedBusinessListList> {
        const response = await this.businessesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async businessesMapMarkersRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessMapMarker>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/map-markers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessMapMarkerFromJSON(jsonValue));
    }

    /**
     */
    async businessesMapMarkersRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessMapMarker> {
        const response = await this.businessesMapMarkersRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async businessesRequestDealCreateRaw(requestParameters: BusinessesRequestDealCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling businessesRequestDealCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/{id}/request-deal/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async businessesRequestDealCreate(requestParameters: BusinessesRequestDealCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.businessesRequestDealCreateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async businessesRetrieveRaw(requestParameters: BusinessesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Business>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling businessesRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessFromJSON(jsonValue));
    }

    /**
     */
    async businessesRetrieve(requestParameters: BusinessesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Business> {
        const response = await this.businessesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Provide the n best search results based on the search query provided.
     */
    async businessesSearchListRaw(requestParameters: BusinessesSearchListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BusinessSearch>>> {
        if (requestParameters.query === null || requestParameters.query === undefined) {
            throw new runtime.RequiredError('query','Required parameter requestParameters.query was null or undefined when calling businessesSearchList.');
        }

        const queryParameters: any = {};

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/search/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BusinessSearchFromJSON));
    }

    /**
     * Provide the n best search results based on the search query provided.
     */
    async businessesSearchList(requestParameters: BusinessesSearchListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BusinessSearch>> {
        const response = await this.businessesSearchListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async businessesSettingsPartialUpdateRaw(requestParameters: BusinessesSettingsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessSettings>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling businessesSettingsPartialUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/{id}/settings/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedBusinessSettingsToJSON(requestParameters.PatchedBusinessSettings),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessSettingsFromJSON(jsonValue));
    }

    /**
     */
    async businessesSettingsPartialUpdate(requestParameters: BusinessesSettingsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessSettings> {
        const response = await this.businessesSettingsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async businessesSettingsRetrieveRaw(requestParameters: BusinessesSettingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessSettings>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling businessesSettingsRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/{id}/settings/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessSettingsFromJSON(jsonValue));
    }

    /**
     */
    async businessesSettingsRetrieve(requestParameters: BusinessesSettingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessSettings> {
        const response = await this.businessesSettingsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async businessesSettingsUpdateRaw(requestParameters: BusinessesSettingsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessSettings>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling businessesSettingsUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/{id}/settings/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BusinessSettingsToJSON(requestParameters.BusinessSettings),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessSettingsFromJSON(jsonValue));
    }

    /**
     */
    async businessesSettingsUpdate(requestParameters: BusinessesSettingsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessSettings> {
        const response = await this.businessesSettingsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async businessesUnfavoriteCreateRaw(requestParameters: BusinessesUnfavoriteCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling businessesUnfavoriteCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/{id}/unfavorite/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async businessesUnfavoriteCreate(requestParameters: BusinessesUnfavoriteCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.businessesUnfavoriteCreateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async businessesUnrequestDealCreateRaw(requestParameters: BusinessesUnrequestDealCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling businessesUnrequestDealCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/businesses/{id}/unrequest-deal/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async businessesUnrequestDealCreate(requestParameters: BusinessesUnrequestDealCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.businessesUnrequestDealCreateRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const BusinessesListAmenitiesEnum = {
    NUMBER_1: 1,
    NUMBER_10: 10,
    NUMBER_11: 11,
    NUMBER_12: 12,
    NUMBER_13: 13,
    NUMBER_14: 14,
    NUMBER_15: 15,
    NUMBER_16: 16,
    NUMBER_17: 17,
    NUMBER_18: 18,
    NUMBER_19: 19,
    NUMBER_2: 2,
    NUMBER_20: 20,
    NUMBER_21: 21,
    NUMBER_22: 22,
    NUMBER_23: 23,
    NUMBER_25: 25,
    NUMBER_26: 26,
    NUMBER_27: 27,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9
} as const;
export type BusinessesListAmenitiesEnum = typeof BusinessesListAmenitiesEnum[keyof typeof BusinessesListAmenitiesEnum];
/**
 * @export
 */
export const BusinessesListCuisinesEnum = {
    NUMBER_1: 1,
    NUMBER_10: 10,
    NUMBER_11: 11,
    NUMBER_12: 12,
    NUMBER_13: 13,
    NUMBER_14: 14,
    NUMBER_15: 15,
    NUMBER_16: 16,
    NUMBER_17: 17,
    NUMBER_18: 18,
    NUMBER_19: 19,
    NUMBER_2: 2,
    NUMBER_20: 20,
    NUMBER_21: 21,
    NUMBER_22: 22,
    NUMBER_23: 23,
    NUMBER_24: 24,
    NUMBER_25: 25,
    NUMBER_26: 26,
    NUMBER_27: 27,
    NUMBER_28: 28,
    NUMBER_29: 29,
    NUMBER_3: 3,
    NUMBER_30: 30,
    NUMBER_31: 31,
    NUMBER_32: 32,
    NUMBER_33: 33,
    NUMBER_34: 34,
    NUMBER_35: 35,
    NUMBER_36: 36,
    NUMBER_37: 37,
    NUMBER_38: 38,
    NUMBER_39: 39,
    NUMBER_4: 4,
    NUMBER_40: 40,
    NUMBER_41: 41,
    NUMBER_42: 42,
    NUMBER_43: 43,
    NUMBER_44: 44,
    NUMBER_45: 45,
    NUMBER_46: 46,
    NUMBER_47: 47,
    NUMBER_48: 48,
    NUMBER_49: 49,
    NUMBER_5: 5,
    NUMBER_50: 50,
    NUMBER_51: 51,
    NUMBER_52: 52,
    NUMBER_53: 53,
    NUMBER_54: 54,
    NUMBER_55: 55,
    NUMBER_56: 56,
    NUMBER_57: 57,
    NUMBER_58: 58,
    NUMBER_59: 59,
    NUMBER_6: 6,
    NUMBER_60: 60,
    NUMBER_61: 61,
    NUMBER_62: 62,
    NUMBER_63: 63,
    NUMBER_64: 64,
    NUMBER_65: 65,
    NUMBER_66: 66,
    NUMBER_67: 67,
    NUMBER_68: 68,
    NUMBER_69: 69,
    NUMBER_7: 7,
    NUMBER_70: 70,
    NUMBER_71: 71,
    NUMBER_72: 72,
    NUMBER_73: 73,
    NUMBER_74: 74,
    NUMBER_75: 75,
    NUMBER_76: 76,
    NUMBER_77: 77,
    NUMBER_78: 78,
    NUMBER_79: 79,
    NUMBER_8: 8,
    NUMBER_80: 80,
    NUMBER_81: 81,
    NUMBER_82: 82,
    NUMBER_83: 83,
    NUMBER_9: 9
} as const;
export type BusinessesListCuisinesEnum = typeof BusinessesListCuisinesEnum[keyof typeof BusinessesListCuisinesEnum];
/**
 * @export
 */
export const BusinessesListDietsEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7
} as const;
export type BusinessesListDietsEnum = typeof BusinessesListDietsEnum[keyof typeof BusinessesListDietsEnum];
/**
 * @export
 */
export const BusinessesListPriceLevelEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;
export type BusinessesListPriceLevelEnum = typeof BusinessesListPriceLevelEnum[keyof typeof BusinessesListPriceLevelEnum];
